export default ['type', 'serviceType', 'source'];
